import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { MailOut, NavArrowRight, Check, SendDiagonal } from 'iconoir-react'
import { theme } from '../../Theme'
import SiteButton from '../../Core/SiteButton'
import { useIntl } from '@jetshop/intl'
import VbInformationBox from '../../Core/Form/VbInformationBox'

const SvgWrapper = styled.div`
   height: 42px;
   width: 42px;

   svg {
      height: 100%;
      width: 100%;
   }
   ${theme.below.md} {

      height: ${props => props.mobileHeight};
      width: ${props => props.mobileWidth};
   }
`

const NewsletterUnregisterWidget = () => {
   const t = useIntl()

   return (
      <VbInformationBox
         title={t('you are now unregistred')}
         // subtitle={t('newsletter-welcome-text')}
         titleIcon={
            <SvgWrapper mobileHeight="3rem" mobileWidth="3rem">
               <SendDiagonal strokeWidth={2.0} width={'100%'} height={'100%'} />
            </SvgWrapper>
         }
         content={
            <>
               <div className="d-flex justify-content-center mt-3">
                  <MailOut color="#59a021" width={111} height={111} />
               </div>
               <div>
                  <SiteButton
                     style={{ padding: '0.8rem 0.8rem 0.8rem 1.5rem' }}
                     href={'/'}
                     styleType="solid"
                     color="blue"
                     size="large"
                     icon={true}
                  >
                     {t('to-startpage')}
                     <NavArrowRight
                        strokeWidth={2.0}
                        style={{ marginLeft: '1rem' }}
                     ></NavArrowRight>
                  </SiteButton>
               </div>
            </>
         }
      ></VbInformationBox>
   )
}

export default NewsletterUnregisterWidget
